<!-- https://svelte.dev/examples#modal -->
<script>
	import { createEventDispatcher } from 'svelte';
	import { util } from '../utils/bookmarksUtil.js';
	import { dbUtil } from '../utils/dbUtil.js';
    import TagsInput from '../utils/TagsInput.svelte';
	import * as urlMetaUtil from '../utils/urlMetadata.js';

	//Event actions
	const dispatch = createEventDispatcher();
	const close = () => {
		dispatch('close');
	};
	const saved = () => dispatch('saved');
	const save = () => {
		addNewLink();
	};
	let previouslyEnteredUrl = 'dummyInitUrl';
	const urlEntered = () => {
		if (newLinkData.link.trim() == '') {
			return;
		}
		let isValidLinkData = isValidLink(newLinkData.link);
		if (!isValidLinkData.isValid) {
			newLinkData.error = isValidLinkData.errorMsg;
			return;
		}
		let isUrlChanged = previouslyEnteredUrl != newLinkData.link;
		if (isUrlChanged) {
			//URL has changed, so remove any old errors
			newLinkData.error = '';

			previouslyEnteredUrl = newLinkData.link;
			metadataPromise = urlMetaUtil.getUrlMeta(newLinkData.link); 
			
			//Disable saving till metadata is fetched
			updateSaveButtonState(true); 
			metadataPromise.then(() => updateSaveButtonState(false));
			populateMetadata();
		} else {
			console.debug('URL hasn\'t changed, not updating metadata.')
		}
	};

	const handleKeydown = e => {
		if (e.key === 'Escape') {
			close();
			return;
		}
	};

	let newLinkData = {
		 error: '',
		 success: '',
		 link: '',
		 tags: [],
		 imgSrc: '',
		 imgData: '',
		 title: '',
		 description: ''
	}

	let metadataPromise;	
	let modal;
	
	function populateMetadata() {
		metadataPromise.then((metadata) => {
			if (metadata && metadata.success) {
				newLinkData.imgSrc = metadata.imgUrl;
				newLinkData.imgData = metadata.imgData;
				newLinkData.title = metadata.title;
				newLinkData.description = metadata.description;
			} else {
				//Todo: Add default values
			}
		})
	}

	
	function isDuplicateLink(inputLink) {
		let bookmarkLinks = util.getBookmarkLinks();
		return bookmarkLinks.has(inputLink);
	}

	function isValidLink(inputLink) {
		let isValid = true;
		let errorMsg;
		if (!inputLink || inputLink.trim() == '') {
			isValid = false;
            errorMsg = 'Enter a link';
        } else if (!inputLink.startsWith('http')) {
            isValid = false;
			errorMsg = 'Invalid link. Links should start with http:// or https://';
        } else if (isDuplicateLink(inputLink)) {
			isValid = false;
			errorMsg = 'The entered link already exists';
		} else {
			try {
				let urlObject = new URL(inputLink);
				isValid = urlObject.protocol == 'http:' || urlObject.protocol == 'https:';
				errorMsg = isValid ? '' : 'Invalid link';
			} catch (error) {
				isValid = false;
				errorMsg = 'Invalid link';
			}
		}
		return {isValid, errorMsg};
	}

	let existingTagsByName = {};
	dbUtil.getTagsByName().then((data) => {
		existingTagsByName = data;
	});
	async function addNewLink() {
		let isValidLinkData = isValidLink(newLinkData.link);
		if (!isValidLinkData.isValid) {
			newLinkData.error = isValidLinkData.errorMsg;
			return;
		} else {
			newLinkData.error = '';
		}

		if (newLinkData.tags == null || newLinkData.tags.length == 0) {
			newLinkData.error = 'Enter a tag';
			return;
		}
        
        let result = await util.addBookmark({
			'link' : newLinkData.link, 
			'title': newLinkData.title,
			'tags' : newLinkData.tags,
			'imgSrc': newLinkData.imgSrc,
			'imgData' : newLinkData.imgData,
			'description': newLinkData.description
		});

		if (result.success) {
        	newLinkData.success = 'Link added!';
			setTimeout(() => {
				newLinkData.link = '';
				newLinkData.tags = [];
				newLinkData.imgSrc = '';
				newLinkData.imgData = '';
				newLinkData.title = '';
				newLinkData.description = '';
				inputLink = '';
				close();
				saved();
			}, 3000);
		} else {
			//This hasn't been saved - don't clear data or close modal.
			newLinkData.error = result.msg;
		}
    }

	let isSaveBtnDisabled = true;
	function updateSaveButtonState(isDisabled) {
		isSaveBtnDisabled = isDisabled;
	}

	export let inputLink = null;
	//If link is sent as input, auto-populate it
	if (inputLink != null && inputLink != '') {
		let isValidLinkData = isValidLink(inputLink);
		if (!isValidLinkData.isValid) {
			newLinkData.error = isValidLinkData.errorMsg;
		} else {
			newLinkData.error = '';
			newLinkData.link = inputLink;

			//Move focus out of link field to trigger focusout() and populate metadata.
			window.onload = function() {
				let tagsField = document.getElementById('new-tags');
				tagsField.focus();
			}
		}
	}
</script>

<svelte:window on:keydown={handleKeydown}/>

<div role="dialog" aria-modal="true" bind:this={modal}>
	<h1>
		Add new bookmark
	</h1>

	<hr>
	<label id="new-link__label" for="new-link">Enter the link*:</label>
	<!-- svelte-ignore a11y-autofocus -->
	<input autocomplete="off" bind:value={newLinkData.link} autofocus type="text" id="new-link" name="new-link" on:focusout={urlEntered} class="inputs"/>
	
	<label id="new-tag__label" for="new-tags">Enter tags*:</label>
	<TagsInput bind:selectedTags={newLinkData.tags}/>
	

	{#await metadataPromise}
		Loading metadata!
	{:then metadata}
		{#if metadata}
			{#if metadata.success}
				<div id="new-image-container">
					<img src={newLinkData.imgData} alt="default from link" id="new-image">
				</div>
				<label id="new-tag__title" for="new-title">Enter title:</label>
				<input bind:value={newLinkData.title} type="text" id="new-title" name="new-title" class="inputs">
				<label id="new-tag__description" for="new-desc">Enter description:</label>
				<input bind:value={newLinkData.description} type="textarea" id="new-desc" name="new-desc" class="inputs">
			{:else}
				<div id="metadata-error">
					Could not get metadata from link.  
					<div id="metadata-error__details">
						In machine-speak, {metadata.errorMsg}.
					</div>
				</div>
			{/if}
		{/if}
	{:catch error}
		<div id="metadata-error">
			Oops, there was an error! :(
				<div id="metadata-error__details"> {error} </div>
		</div>
    {/await}

	<div id="new-link__error">
		{newLinkData.error} 
	</div>
	<div id="new-link__success">
		{newLinkData.success} 
	</div>
	<hr>

    <div class="buttons">
        <button class="btn-secondary" on:click={close}>Cancel</button>
        <button class="btn-primary" on:click={save} disabled={isSaveBtnDisabled}>Save</button>
    </div>
</div>

<style>
    .buttons {
        display: flex;
        gap: 1em;
		margin-top: 1em;
    }

	button {
		display: block;
		width: 100%;
		border: none;
		padding: 0.8em 1.2em;
		border-radius: 8px;
		font-weight: bold;
		cursor: pointer;
		transition: all 0.2s ease-in-out;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.btn-primary {
		background: linear-gradient(to right, var(--primary-color), var(--primary-color-dark));
		color: var(--text-color-light);
	}

	.btn-primary:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	}

	.btn-secondary {
		background: var(--secondary-color);
		color: var(--text-color-light);
	}

	.btn-secondary:hover {
		background: var(--secondary-color-dark);
		transform: translateY(-2px);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	}
	
	button:disabled,
	button[disabled]{
		background: var(--disabled-color);
		color: var(--disabled-text-color);
		cursor: not-allowed;
		box-shadow: none;
		transform: none;
	}

	label {
		font-size: 1.1em;
		margin-top: 1em;
		display: inline-block;
	}

	#new-link__error {
		color: red;
		margin-top: 0.5em;
	}
	#new-link__success {
		color: green;
		margin-top: 0.5em;
	}
	#new-image-container {
		display: flex;
		max-height: 10em;
		margin-top: 0.2em;
		border: 3px solid black;
		border-radius: 5px;
	}
	#new-image {
		display: block;
		margin-left: auto;
		margin-right: auto;
		object-fit: contain;
		overflow: hidden;
	}

	#metadata-error {
		padding: 0.5em;
		display: flex;
		flex-direction: column;
	}
	#metadata-error__details {
		font-size: 0.8em;
		font-style: italic;
		color: #3c3c3c;
	}

</style>